<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RgpcKl/images/Frontcover.jpg?1703001137899" alt="This image is the cover for the book Battles of French Flanders"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Battles of French Flanders
      </h1>
      <p class="bookDescription body article font2">
        <p>The battles fought by the British army in 1915, in the second year of the First World War, are less well known than those fought immediately after the outbreak of war in 1914 and those that followed in 1916 which culminated in the Battle of the Somme. But the fighting at Aubers Ridge, Festubert, Neuve Chapelle and Loos was just as severe  as was the 1916 battle at Fromelles  and the battlefields are just as interesting to explore today. This volume in the Battle Lines series is the perfect guide to them.Expert guides Jon Cooksey and Jerry Murland take visitors over a series of routes that can be walked, biked or driven, explaining the fighting that occurred at each place in vivid detail. They describe what happened, where it happened and why and who was involved, and point out the sights that remain for the visitor to see. Their highly illustrated guidebook is essential reading for visitors who wish to enhance their understanding of warfare on the Western Front.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jon Cooksey, Jerry Murland
      </h2>
      
      <p class="authorDescription body article">Jon Cooksey is a leading military historian who takes a special interest in the history of the world wars. He is the editor of Stand To!, the journal of the Western Front Association, and he is an experienced battlefield guide. His books include The Barnsley Pals, Calais, Harrys War and, as editor, Blood and Iron.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a84f1486